export default "__VITE_ASSET__DxpcT0op__"